import { useDispatch } from 'react-redux';
import Modal from '../custom/Modal';
import Close from '../../assets/images/icons/close.svg';
import React from 'react';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import XS2APrivacyModalCustomization from '../customizations/XS2APrivacyModalCustomization';

const XS2APrivacyModal = () => {
	const dispatch = useDispatch();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.XS2APRIVACY_MODAL));
	};
	return (
		<Modal onClose={handleOnCloseModal}>
			<div className="modal-actions">
				<div className="modal-actions-close" onClick={handleOnCloseModal}>
					<img className="modal-close" src={Close} alt="Close" />
				</div>
			</div>
			<XS2APrivacyModalCustomization />
		</Modal>
	);
};

export default XS2APrivacyModal;
